import { Element } from "slate";
import {
  BlockType,
  InlineType
} from "../types";
const ElementUtils = {
  isRootBlock(node) {
    return Element.isElement(node) && (Element.isElementType(node, BlockType.Paragraph) || Element.isElementType(node, BlockType.Heading1) || Element.isElementType(node, BlockType.Heading2) || Element.isElementType(node, BlockType.Heading3) || Element.isElementType(node, BlockType.Heading3) || Element.isElementType(node, BlockType.Heading4) || Element.isElementType(node, BlockType.Heading5) || Element.isElementType(node, BlockType.Heading6) || Element.isElementType(node, BlockType.BlockQuote) || Element.isElementType(node, BlockType.UnorderedList) || Element.isElementType(node, BlockType.OrderedList) || Element.isElementType(node, BlockType.Default));
  },
  isBlock(node) {
    return Element.isElement(node) && (this.isRootBlock(node) || Element.isElementType(node, BlockType.ListItem) || Element.isElementType(node, BlockType.ListItemChild));
  },
  isInline(node) {
    return Element.isElement(node) && (Element.isElementType(node, InlineType.Code) || Element.isElementType(node, InlineType.Link) || Element.isElementType(node, InlineType.SubScript) || Element.isElementType(node, InlineType.SuperScript));
  },
  isConvertibleToListTextNode(node) {
    return !this.isList(node) && !this.isListItem(node) && !this.isListItemChild(node);
  },
  isList(node) {
    return Element.isElementType(node, BlockType.OrderedList) || Element.isElementType(node, BlockType.UnorderedList);
  },
  isListItem(node) {
    return Element.isElementType(node, BlockType.ListItem);
  },
  isListItemChild(node) {
    return Element.isElementType(node, BlockType.ListItemChild);
  },
  createText() {
    return { text: "" };
  },
  createParagraph() {
    return {
      children: [this.createText()],
      type: BlockType.Paragraph
    };
  },
  createList(type = BlockType.UnorderedList) {
    return { children: [this.createText()], type };
  },
  createListItem() {
    return {
      children: [this.createListItemChild()],
      type: BlockType.ListItem
    };
  },
  createListItemChild() {
    return {
      children: [this.createText()],
      type: BlockType.ListItemChild
    };
  }
};
export {
  ElementUtils
};
//# sourceMappingURL=element.js.map